// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"07e86e0c","810":"b35ebabc"}[chunkId] + ".chunk.js";
};